import React from "react";
import { ReactComponent as SearchIcon } from "svgs/fi-rs-search.svg";
import { useSettings } from "hooks/useStore";
import clsx from "clsx/lite";

const SearchButton = ({ embedHeader }) => {
	const { isSearchOpen, toggleSearch } = useSettings(["isSearchOpen", "toggleSearch"]);
	return (
		<button
			onClick={toggleSearch}
			aria-label="search"
			className={clsx("t-search-icon hidden md:block", embedHeader && "invert")}
		>
			<SearchIcon className={clsx("transition-all duration-300", isSearchOpen ? "rotate-90" : "rotate-0")} />
		</button>
	);
};

export default SearchButton;